export namespace UniqueIdentifierServices {
    (<any>window).uniqueIdSeed = (<any>window).uniqueIdSeed || 1;
    (<any>window).uniqueIdLinkHash = (<any>window).uniqueIdLinkHash || {};

    function nextId() {
        return (<any>window).uniqueIdSeed++;
    }

    export function GetOneTimeUseNewIdentifier(): string {
        return `unique-identifier-${nextId()}`;
    }

    export function AddNewIdentifier(valueAccessor: any): string {
        const response = GetOneTimeUseNewIdentifier();
        (<any>window).uniqueIdLinkHash[valueAccessor] = response;

        return response;
    }

    export function RetrieveLinkHash(valueAccessor: any): string {
        return (<any>window).uniqueIdLinkHash[valueAccessor];
    }

    export function RemoveLinkHash(valueAccessor: any): void {
        (<any>window).uniqueIdLinkHash[valueAccessor] = undefined;
    }
}
